import * as React from 'react';
import * as styles from './styles.css';

import { UIText2, ArticleHeading4, Button } from '@cian/ui-kit';
import { WorkHonestly } from '../WorkHonestly';

import { Stars } from '../packages/Stars';
import { AgentType, RgrCertificate } from '../RgrCertificate';
import { getNoun } from '../../utils/getNoun';

export interface IRealtorCardProps {
  previewImg: React.ReactNode;
  timeOnSite: string | undefined | null;
  agencyName: string | undefined | null;
  agentId: number;
  hasRgrParticipation: boolean;
  name?: string | null;
  rate?: number | null;
  reviewsCount?: number | null;
  onClick(): void;
  levelNumber?: number | null;
  levelName?: string | null;
  selectRealtor: () => void;
  unselectRealtor: () => void;
  isSelected: boolean;
  disabledButton: boolean;
}

export function RealtorCard({
  previewImg,
  timeOnSite,
  agencyName,
  agentId,
  name,
  rate,
  reviewsCount,
  onClick,
  levelName,
  levelNumber,
  hasRgrParticipation,
  selectRealtor,
  unselectRealtor,
  isSelected,
  disabledButton,
}: IRealtorCardProps) {
  const reviewsCountText = reviewsCount
    ? `${reviewsCount} ${getNoun(reviewsCount, ['отзыв', 'отзыва', 'отзывов'])}`
    : 'Нет отзывов';

  const onSelectRealtorClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (isSelected) {
      unselectRealtor();
    } else {
      selectRealtor();
    }
  };

  return (
    <div className={styles['container']} onClick={onClick}>
      <div className={styles['one-column']}>
        <div className={styles['img']}>{previewImg}</div>
        <div className={styles['text-info']}>
          <div>
            <div className={styles['name']}>
              <span>{name}</span>
              <WorkHonestly levelNumber={levelNumber} levelName={levelName} />

              {hasRgrParticipation && <RgrCertificate type={AgentType.Realtor} />}
            </div>
          </div>
          <div>
            <UIText2 color="black_60">{agencyName}</UIText2>
          </div>
          <div>
            <UIText2 color="black_60">{timeOnSite}</UIText2>
          </div>
        </div>
      </div>
      <div className={styles['two-column']}>
        <div className={styles['left']}>
          {rate && (
            <div className={styles['rating']}>
              <ArticleHeading4>{(rate * 5).toFixed(1)}</ArticleHeading4>
              <div className={styles['stars']}>
                <Stars uniqueKey={`${agentId}`} value={rate} />
              </div>
            </div>
          )}
          <div className={styles['reviews']}>
            <UIText2 color="black_60">{reviewsCountText}</UIText2>
          </div>
        </div>
        <div className={styles['right']}>
          <Button
            onClick={onSelectRealtorClick}
            theme={isSelected ? 'fill_white_primary' : 'fill_secondary'}
            disabled={disabledButton && !isSelected}
            size="XS"
          >
            {isSelected ? 'Отменить выбор' : 'Выбрать'}
          </Button>
        </div>
      </div>
    </div>
  );
}
